import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import isCardExpired from 'bl/plan/isCardExpired.bl';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import { selectBillingCardData } from 'selectors/settings.selectors';
import linkTo from 'utils/links/linkTo.util';

import CN from './NoBillingModal.module.scss';

const NoBillingModal = ({ isOpen, onClose, salonId, onClick, customButtonAction, stripeCardData }) => {
  const { t } = useTranslation();
  const { expiry_year: expiryYear, expiry_month: expiryMonth } = stripeCardData;

  const expired = isCardExpired(expiryMonth, expiryYear);

  return (
    <SalonModal tag="NoBillingModal-modal" isOpen={isOpen}>
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.modalImage}>
          <div className={CN.iconContainer}>
            <Icon variant="alert" />
          </div>
        </div>
        <div className={CN.modalContent}>
          <div className={CN.modalTitle}>{t('composite.noBillingModal.title')}</div>
          <div className={CN.modalText}>
            {t('composite.noBillingModal.descriptionPart1')}
            <br />
            {t('composite.noBillingModal.descriptionPart2')}
          </div>
          <br />
          {expired && <div className={CN.error}>{t('composite.noBillingModal.expiredMessage')}</div>}
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        {customButtonAction ? (
          <Button variant="primaryForce" onClick={onClick}>
            {t('composite.noBillingModal.confirm')}
          </Button>
        ) : (
          <NavLink to={linkTo({ pattern: LINK.billing, params: { salonId }, fault: '#' })}>
            <Button variant="primaryForce">
              <span className={CN.buttonSpace}>{t('composite.noBillingModal.confirm')}</span>
            </Button>
          </NavLink>
        )}
      </SalonModal.Footer>
    </SalonModal>
  );
};

const mapStateToProps = (state) => ({
  salonId: selectCurrentSalonId(state),
  stripeCardData: selectBillingCardData(state),
});

const NoBillingModalHoc = connect(mapStateToProps)(NoBillingModal);

export default NoBillingModalHoc;
